module.exports = __webpack_public_path__ + "static/media/smileRating2Active.771a7531.svg";